import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ExpenseService from "../../services/expense.service";

export const getExpense = createAsyncThunk(
  "expense/getExpense",
  async (params, thunkAPI) => {
    try {
      const response = await ExpenseService.getExpense(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addExpense = createAsyncThunk(
  "expense/addExpense",
  async (data, thunkAPI) => {
    try {
      const response = await ExpenseService.addExpense(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updateExpense = createAsyncThunk(
  "expense/updateExpense",
  async (payload, thunkAPI) => {
    try {
      const response = await ExpenseService.editExpense(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deleteExpense = createAsyncThunk(
  "expense/deleteExpense",
  async (id, thunkAPI) => {
    try {
      await ExpenseService.deleteExpense(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =================== State =================== */

const initialState = {
  loading: false,
  error: null,
  expenseList: [],
  updateSuccess: false,
};

/* =================== Slice =================== */

const expenseSlice = createSlice({
  name: "expense",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      /* ---------- Get ---------- */
      .addCase(getExpense.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getExpense.fulfilled, (state, action) => {
        state.loading = false;
        state.expenseList = action.payload?.data || [];
      })
      .addCase(getExpense.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add ---------- */
      .addCase(addExpense.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addExpense.fulfilled, (state, action) => {
        state.loading = false;
        const newHotel =
          action.payload?.data ||
          action.payload?.expense ||
          action.payload;

        if (newHotel) {
          state.expenseList.unshift(newHotel);
        }
      })
      .addCase(addExpense.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Update ---------- */
      .addCase(updateExpense.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updateExpense.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;

        const updated =
          action.payload?.data || action.payload?.expense;

        if (updated?._id) {
          const index = state.expenseList.findIndex(
            (item) => item._id === updated._id
          );
          if (index !== -1) {
            state.expenseList[index] = updated;
          }
        }
      })
      .addCase(updateExpense.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Delete ---------- */
      .addCase(deleteExpense.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteExpense.fulfilled, (state, action) => {
        state.loading = false;
        state.expenseList = state.expenseList.filter(
          (item) => item._id !== action.payload
        );
      })
      .addCase(deleteExpense.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateStatus } = expenseSlice.actions;
export default expenseSlice.reducer;
